// AuthTeamJoinFlow (contract 06 §8): set the invited user's first password, then enter the one
// canonical account bootstrap. The composable owns navigation; all failures collapse to the
// stable team-join error key so server prose never reaches the screen.
import type { ChangePasswordPayloadV2 } from '../models/auth.types'
import { authService, type AuthService } from '../service/AuthService'

import { AccountBootstrapFlow } from '@/features/account'

interface AccountBootstrap {
  execute(reload?: boolean): Promise<void>
}

export interface AuthTeamJoinDeps {
  service?: AuthService
  bootstrap?: AccountBootstrap
}

export class AuthTeamJoinFlow {
  private readonly service: AuthService
  private readonly bootstrap: AccountBootstrap

  constructor(deps: AuthTeamJoinDeps = {}) {
    this.service = deps.service ?? authService
    this.bootstrap = deps.bootstrap ?? new AccountBootstrapFlow()
  }

  async submitPassword(payload: ChangePasswordPayloadV2): Promise<{ ok: true }> {
    await this.service.submitTeamJoinPassword(payload)
    await this.bootstrap.execute()
    return { ok: true }
  }
}
